import { ButtonEmptyPermissioned } from "components/ButtonEmptyPermissioned/ButtonEmptyPermissioned";

interface ColumnHeaderActionRemoveColumnProps {
  onClick: () => void;
  isDisabled?: boolean;
}

export const ColumnHeaderActionRemoveColumn = ({
  onClick,
  isDisabled = false,
}: ColumnHeaderActionRemoveColumnProps) => {
  return (
    <ButtonEmptyPermissioned
      requiredPermission="edit"
      aria-label="Remove column"
      onClick={onClick}
      iconType="trash"
      color="text"
      size="s"
      disabled={isDisabled}
    >
      Remove column
    </ButtonEmptyPermissioned>
  );
};
